import BottomLayout from './BottomLayout';
export default BottomLayout;
